import { CardPaymentNew } from '@mafc/icon';
import { Box } from '@mafc/trolly';

import * as S from './NewCreditCardItem.style';

const NewCreditCardItem: React.FC<{
  title: string;
  subTitle?: string;
}> = ({ title, subTitle }) => {
  return (
    <S.NewCreditCardItem>
      <CardPaymentNew />
      <S.TitleWrapper>
        <S.Title>{title}</S.Title>
        {subTitle && <Box>{subTitle}</Box>}
      </S.TitleWrapper>
    </S.NewCreditCardItem>
  );
};

export default NewCreditCardItem;
